import jwt from 'jsonwebtoken';
import * as _ from 'lodash';

export function checkScope(token: string, requiredScope: string): boolean {
  const decoded = jwt.decode(token);
  const scope = _.get(decoded, 'scope');

  if (scope) {
    const scopes = scope.split(' ');
    return scopes.includes(requiredScope);
  }

  return false;
}
